module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_banner !== false) ? _c('section', {
    staticClass: "credits"
  }, [_c('div', [_c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer.banner', {
        link: _vm.site.url,
        name: _vm.site.name
      }))
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3223b53a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer-bar.vue
// module id = 251
// module chunks = 1